export enum CmCustomerAssessmentResultEnum {

    not_applicable,
    poor,
    below_average,
    average,
    good,
    excellent

}